var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoNothumbnailPlayicon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.36 124.36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#126CFC;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Video") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.36,106.21V18.15A18.17,18.17,0,0,0,106.21,0H18.15A18.17,18.17,0,0,0,0,18.15v88.06a18.17,18.17,0,0,0,18.15,18.15h88.06A18.17,18.17,0,0,0,124.36,106.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.31,35.55a.85.85,0,0,0-1.28.73V87.43a.85.85,0,0,0,1.28.74L87.61,62.6a.86.86,0,0,0,0-1.48Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoNothumbnailPlayicon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjQuMzYgMTI0LjM2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzEyNkNGQzt9LmNscy0ye2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlZpZGVvPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyNC4zNiwxMDYuMjFWMTguMTVBMTguMTcsMTguMTcsMCwwLDAsMTA2LjIxLDBIMTguMTVBMTguMTcsMTguMTcsMCwwLDAsMCwxOC4xNXY4OC4wNmExOC4xNywxOC4xNywwLDAsMCwxOC4xNSwxOC4xNWg4OC4wNkExOC4xNywxOC4xNywwLDAsMCwxMjQuMzYsMTA2LjIxWiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTQzLjMxLDM1LjU1YS44NS44NSwwLDAsMC0xLjI4LjczVjg3LjQzYS44NS44NSwwLDAsMCwxLjI4Ljc0TDg3LjYxLDYyLjZhLjg2Ljg2LDAsMCwwLDAtMS40OFoiLz48L2c+PC9nPjwvc3ZnPg==";